export { default as de } from './de';
export { default as en } from './en';
export { default as es } from './es';
export { default as fr } from './fr';
export { default as ptBR } from './ptBR';
export { default as ru } from './ru';
export { default as zh } from './zh';
export { default as nl } from './nl';
//# sourceMappingURL=index.js.map